import React, { useState } from 'react';

function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = false,
  children,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className={`border border-gray-200 rounded-lg overflow-hidden bg-white ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full flex items-center justify-between gap-3 p-4 text-left hover:bg-gray-50 transition-colors"
        aria-expanded={open}
      >
        <div className="min-w-0">
          <h3 className="font-semibold text-gray-800">{title}</h3>
          {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
        <span
          className={`shrink-0 text-gray-500 text-xs font-medium px-2 py-1 rounded border border-gray-200 bg-gray-50 ${open ? '' : ''}`}
          aria-hidden
        >
          {open ? 'Hide' : 'Show'}
        </span>
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1 border-t border-gray-100">
          {children}
        </div>
      )}
    </section>
  );
}

export default CollapsibleSection;
